import styled from 'styled-components';
import { colors, grid } from './constants';

export default styled.h4`
  transition: background-color ease 0.2s;
  flex-grow: 1;
  user-select: none;
  position: relative;
  text-align: center;
  margin: 0px;
  &:focus {
    outline: 2px solid ${colors.purple};
    outline-offset: 2px;
  }
`;



// WEBPACK FOOTER //
// ./src/containers/Dashboard/Title.js